import { fetchProjectsApi } from "../../api/project";
import { addProjects } from "../../indexDB/utils/project";
import { fetchDatasetsApi } from "../../api/dataset";
import { addDataset } from "../../indexDB/utils/dataset";
import { storeUser } from "../../indexDB/utils/user";
import React, { useEffect, useState, useRef } from "react";
//import { useErrorBoundary } from "react-error-boundary";

export async function loadForms (token){
    //const { showBoundary } = useErrorBoundary();
    const projectsRef = {current:[]};
    const username = process.env.MAGIC_USERNAME;
    localStorage.setItem("username",username);
    const fetchDatasetsForProjects = async () => {
        const projectsData = projectsRef.current;
        if (projectsData.length > 0) {
          for (const project of projectsData) {
            try {
              const datasetsData = await fetchDatasetsApi(project.id);
              await addDataset(datasetsData);
            } catch (error) {
              console.log(error);
            }
          }
        }
      };

    try {
        localStorage.setItem("token", token);
        const magicEmail = process.env.MAGIC_EMAIL || "magic@email";
        const magicUsername = process.env.MAGIC_USERNAME || "magic_username";
        const magicPassword = process.env.MAGIC_PASSWORD || "magic_password";
        await storeUser(magicEmail, magicUsername, magicPassword);
        
        localStorage.setItem("username", magicUsername);
        const projectsData = await fetchProjectsApi(magicUsername);
        console.log(projectsData)
        if (projectsData) {
          projectsRef.current = projectsData;
          await addProjects(projectsData);
        }
        await fetchDatasetsForProjects();
      } catch (error) {
        console.log(error);
      }
}